"use client";

/**
 * The Line moves you (spec 2026-09-17 §5.4, R-NAV-9). A spoken app_control or
 * open_url lands in the live store from the socket handler; this consumer,
 * mounted by AppShell beside the Dock so it is on EVERY app route (the task
 * page and support included, where there is no dock), performs it through the
 * belt the typed lane uses and clears it. The line is app-wide and outlives
 * the dock (useLine is mount-agnostic, the store holds the mic), so the
 * consumer must be too. Cleared BEFORE the belt runs, so a belt that refuses
 * (a blocked open) never loops. Renders nothing.
 *
 * It carries the parked door the same way (R1): a spoken history or tray on a
 * route with no Dock rides to /home first, and opens there when the route
 * lands, so the spoken "Your history is open." stays true.
 */
import { useEffect } from "react";
import { usePathname, useRouter } from "next/navigation";
import { performRouterAction } from "@/components/composer/routerActions";
import { isDockVisible } from "@/lib/home-flags";
import { openLineDoor } from "./linePanels";
import { useLiveStore } from "./liveStore";

export function LineActions() {
  const router = useRouter();
  const pathname = usePathname();
  const action = useLiveStore((s) => s.pendingAction);
  const door = useLiveStore((s) => s.pendingDoor);
  useEffect(() => {
    if (!action) return;
    useLiveStore.setState({ pendingAction: null });
    performRouterAction(action, router);
  }, [action, router]);
  // A level, not an edge: the door waits until a route that paints the Dock is
  // on screen, so one push is enough and a navigation of the person's own
  // (they went home themselves) opens it just as well.
  useEffect(() => {
    if (!door) return;
    if (!isDockVisible(pathname)) {
      router.push("/home");
      return;
    }
    useLiveStore.getState().setPendingDoor(null);
    openLineDoor(door);
  }, [door, pathname, router]);
  return null;
}
